function showToast(message, duration = 5000) {
  return; // Temporarily disable toast messages
  // Create wrapper if it doesn't exist
  let toastWrapper = document.getElementById("toast-wrapper");

  if (!toastWrapper) {
    toastWrapper = document.createElement("div");
    toastWrapper.id = "toast-wrapper";
    document.body.appendChild(toastWrapper);
  }

  // Create toast element
  const toast = document.createElement("div");
  toast.className = "custom-toast";
  toast.id = "custom-toast-" + Date.now();

  toast.innerHTML = `
    <div class="toast-content">
      <span class="toast-message">${message}</span>
      <button class="toast-close-btn" aria-label="Close">&times;</button>
    </div>
    <div class="toast-progress-bar-container">
      <div class="toast-progress-bar"></div>
    </div>
  `;

  toastWrapper.appendChild(toast);

  // Trigger animation
  setTimeout(() => toast.classList.add("show"), 10);

  const progressBar = toast.querySelector(".toast-progress-bar");
  let timeLeft = duration;
  const updateInterval = 50;

  const intervalId = setInterval(() => {
    timeLeft -= updateInterval;
    const progress = (timeLeft / duration) * 100;
    progressBar.style.width = `${progress}%`;

    if (timeLeft <= 0) clearInterval(intervalId);
  }, updateInterval);

  const hide = () => {
    clearInterval(intervalId);
    toast.classList.remove("show");

    toast.addEventListener(
      "transitionend",
      () => {
        toast.remove();
      },
      { once: true },
    );
  };

  const timeoutId = setTimeout(hide, duration);

  // Manual close
  toast.querySelector(".toast-close-btn").addEventListener("click", () => {
    clearTimeout(timeoutId);
    hide();
  });
}

function getTrackingCookie(name) {
  if (typeof getCookie === "function") {
    return getCookie(name);
  }

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(";").shift());
  }

  return null;
}

function fireCartPincodeGAEvent(pincode, isEligible, source) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "pincode_entered",
    pincode: String(pincode),
    pincode_eligible: Boolean(isEligible),
    pincode_source: source,
    utm_source: getTrackingCookie("utm_source_track"),
    utm_medium: getTrackingCookie("utm_medium_track"),
    utm_campaign: getTrackingCookie("utm_campaign_track"),
    utm_term: getTrackingCookie("utm_term_track"),
    utm_content: getTrackingCookie("utm_content_track"),
  });
}

let isCartOpen = false;
let shopifyLocale = Shopify.locale.split("-")[0];
let localeCountry = `${shopifyLocale}-${Shopify.country}`;
const shopCurrency = Shopify.currency.active;
function currencyES6Format(money) {
  const parts = new Intl.NumberFormat(localeCountry, {
    style: "currency",
    currency: shopCurrency,
  }).formatToParts(money);

  return parts
    .map((part) => (part.type === "currency" ? part.value + " " : part.value))
    .join("");
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), delay);
  };
}

var hostname = window.location.hostname;
var link = `https://${hostname}/cart.json`;

async function getData() {
  let x = await fetch(link);
  let data = await x.json();
  window.updatedCartJson = data;
  return data;
}

const checkEnableUpdateCart = async () => {
  if (!simply?.warrantyEnable) {
    const items = window.updatedCartJson?.items;
    if (items && Array.isArray(items)) {
      for (const item of items) {
        let properties = item?.properties;
        if (properties?._bid && properties?._main_product) {
          await removeLineItem({ updates: { [item.key]: 0 } });
          simply.reRenderCart();
        } else if (properties?._bid && properties?._is_warranty_added) {
          delete properties["_bid"];
          delete properties["_is_warranty_added"];

          let addData = {
            id: item.variant_id,
            quantity: item.quantity,
            properties: properties,
          };
          await removeLineItem({ updates: { [item.key]: 0 } });
          await addLineItem([addData]);
          simply.reRenderCart();
        }
      }
    }
  }
};

setTimeout(() => {
  checkEnableUpdateCart();
}, 3000);

const removeLineItem = async (updates) => {
  const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });
  return await res.json();
};

const addLineItem = async (add) => {
  const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: add }),
  });
  return await res.json(add);
};

var dropdowncart = () => {
  isCartOpen = true;
  $("body").css("overflow", "hidden");
  $("#cart_drawer").addClass("loader");
  $(".shipping-at").hide();

  return getData().then(async (data) => {
    $("#cart_drawer").removeClass("loader");
    $(".shipping-at").show();
    var item_count = data["item_count"];
    var total_price = data["total_price"] / 100;

    // Convenience fee logic
    let convenienceFee = 0;
    let hasEligibleProduct = false;

    data.items.forEach((item) => {
      const price = item.price / 100; // per unit price
      const qty = item.quantity;
      hasEligibleProduct = true;
      const feePerItem = 500;
      convenienceFee += feePerItem * qty;
    });

    const isPincode = getCookie("user_pincode");
    const isExpress = getCookie("isExpress") === "true";
    const sapCode = getCookie("sapCode");

    if (!isPincode && item_count > 0) {
      showCartPincodePopup();
    } else {
      hideCartPincodePopup();
    }

    let showExpressShipping = false;

    if (isExpress) {
      showExpressShipping = true;
    } else {
      $(".shipping-at").hide();
      $(".sd_shipping.default-shipping").hide();
    }

    if (hasEligibleProduct && convenienceFee > 0 && isPincode && isExpress) {
      $("#convenience-total span").text(
        currencyES6Format(convenienceFee.toFixed(2)),
      );
      $(".convenience").css("display", "flex");
    } else {
      $(".convenience").hide();
    }

    $("#cart_item_count").html(
      "<span>(" + item_count + ")</span> Items in your cart",
    );
    $("#mini_cart_total").text(currencyES6Format(total_price.toFixed(2)));

    $(".custom_cart_count").html(item_count);
    $(".product-count-cart").html(item_count);

    var upi_discount = Math.round(total_price * 0.03);
    var emi_discount = Math.round(total_price * 0.18);

    $(".upi-offers strong").text("₹ " + upi_discount);
    $(".gst-offers strong").text("₹ " + emi_discount);

    let allItemsHaveExpressStock = true;
    let aspResultsMap = {};
    let anyHyperlocal = false;

    if (item_count > 0) {
      $(".minitotal.total,.sd_sidebar_check").show();
      // $(".shipping-at").show()
      // NOTE: .product-outer.empty() moved to right before .append() below.
      // Emptying here caused a blank-cart flicker during the long async window
      // (stock check + ASP check + cart re-fetch) before items were rendered.

      // Collect all SKUs from cart items
      const allSkusInCart = data.items
        .filter((item) => item.sku) // Ensure SKU exists
        .map((item) => item.sku);

      // ASP fulfilment data (Shopify stock + ASP tag per variant) — started now, awaited
      // before render so it runs in parallel with the stock + ASP checks below
      const aspCartStockPromise =
        typeof window.AspPincodeCart !== "undefined"
          ? fetchAspCartStock()
          : Promise.resolve({});

      let stockResultsMap = new Map();
      if (
        isExpress &&
        sapCode &&
        allSkusInCart.length > 0 &&
        typeof SymphonyStockChecker !== "undefined"
      ) {
        const results = await SymphonyStockChecker.checkStock(
          allSkusInCart,
          sapCode,
        );
        results.forEach((item) => {
          stockResultsMap.set(item.Material, item.Quantity);
        });
      }

      // (d) Bottom loading: show while checkAll is in flight
      if (typeof window.AspPincodeCart !== "undefined" && isPincode) {
        $(".shipping-at").show();
        $(".shipping-at .sd_shipping.express-shipping b").html(
          "<span>Checking delivery options...</span>",
        );
      }

      // (b+c) ASP check — checkAll now returns { results, changed }
      // c: submitCartPincode already calls dropdowncart() after setting the pincode cookie,
      //    so checkAll here automatically picks up the new pincode — no extra call needed.
      if (typeof window.AspPincodeCart !== "undefined" && isPincode) {
        const { results: aspMap, changed: aspChanged } =
          await window.AspPincodeCart.checkAll(data.items);
        aspResultsMap = aspMap;
        // Drop the suffix as soon as ANY cart item is hyperlocal-confirmed — checked
        // via the live ASP result (source === 'asp') OR the persisted _isASP line
        // item property (in case a previous checkAll cycle already confirmed it).
        anyHyperlocal = data.items.some((item) => {
          const liveResult = aspResultsMap[String(item.variant_id)];
          return (
            (liveResult && liveResult.source === "asp") ||
            item.properties?._isASP === "true"
          );
        });

        // (b) Only re-fetch /cart.js when checkAll actually wrote properties
        // (property writes regenerate line item keys — stale keys cause "no valid id" errors).
        // Skipping this when nothing changed saves one /cart.js round-trip per cart open.
        if (aspChanged) {
          try {
            const freshRes = await fetch("/cart.js");
            const freshCart = await freshRes.json();
            data = Object.assign({}, data, { items: freshCart.items });
          } catch (_) {}
        }
      }

      const aspCartStock = await aspCartStockPromise;
      const cartQtyByVariant = {};
      data.items.forEach((cartItem) => {
        const id = String(cartItem.variant_id);
        cartQtyByVariant[id] = (cartQtyByVariant[id] || 0) + cartItem.quantity;
      });
      let anyAspBlocked = false;

      const itemPromises = data.items.map(async (item) => {
        const {
          id: item_id,
          sku: item_sku,
          product_title,
          handle: product_handle,
          quantity,
          line_price: raw_line_price,
          url,
          image: image_url,
          key: variants_key,
          variant_title,
          properties,
        } = item;

        const line_price = raw_line_price / 100;
        const isWarranty =
          properties?.["_is_warranty_added"] || properties?.["_main_product"];
        const isMain = properties?.["_main_product"];

        let availableStock = -1; // Default to -1 if check not performed or failed
        if (isExpress && sapCode && item_sku && stockResultsMap.has(item_sku)) {
          availableStock = stockResultsMap.get(item_sku);
        }

        if (
          isExpress &&
          availableStock !== -1 && // Check if stock was actually retrieved
          quantity > availableStock
        ) {
          allItemsHaveExpressStock = false;
        }

        const truckImg = `<img src="https://cdn.shopify.com/s/files/1/0567/7534/4185/files/delivery-truck.svg?v=1712554063" height="11" width="20" alt="Delivery Truck">`;
        const aspItemResult = aspResultsMap[String(item.variant_id)];

        let customDeliveryMessage = null;
        if (isPincode && typeof window.PincodeExpress !== "undefined") {
          const context =
            window.PincodeExpress.getDeliveryContext(
              isPincode,
              item.variant_id,
            ) ||
            window.PincodeExpress.getDeliveryContext(isPincode, item_sku) ||
            window.PincodeExpress.getDeliveryContext(
              isPincode,
              item.product_id,
            );
          if (context && context.isCustom) {
            customDeliveryMessage =
              context.cartMessage || context.expressMessage;
          }
        }

        // ASP fulfilment gate: ASP-tagged item whose cart quantity exceeds Shopify stock
        // ("Continue selling when out of stock") can only be bought if ASP confirms it.
        const aspStockInfo = aspCartStock[String(item.variant_id)];
        const needsAspConfirmation =
          !!aspStockInfo &&
          aspStockInfo.asp &&
          aspStockInfo.tracked &&
          (cartQtyByVariant[String(item.variant_id)] || 0) > aspStockInfo.stock;
        const aspConfirmed = aspItemResult && aspItemResult.source === "asp";

        let shippingIconHTML;
        if (needsAspConfirmation && !aspConfirmed) {
          anyAspBlocked = true;
          const blockedMsg = isPincode
            ? "Out of stock at your pincode"
            : "Enter your pincode to check availability";
          shippingIconHTML = `<div class="shipping-icon asp-unavailable"><p>${blockedMsg}</p></div>`;
        } else if (aspConfirmed) {
          // Delivery priority: ASP → Porter → Express
          shippingIconHTML = `<div class="shipping-icon freequick">${truckImg}<p>${aspItemResult.message}</p></div>`;
        } else if (customDeliveryMessage) {
          // Custom delivery (Porter) — still respect stock check
          if (
            availableStock !== null &&
            availableStock !== -1 &&
            quantity <= availableStock
          ) {
            shippingIconHTML =
              typeof window.DeliveryConfig?.formatPorterCartHtml === "function"
                ? window.DeliveryConfig.formatPorterCartHtml(
                    customDeliveryMessage,
                  )
                : `<div class="shipping-icon freequick">${truckImg}<p>${customDeliveryMessage}</p></div>`;
          } else {
            shippingIconHTML = `<div class="shipping-icon">${truckImg}<p>${window.DeliveryConfig.standardItemMessage()}</p></div>`;
          }
        } else if (aspItemResult && aspItemResult.source === "asp-standard") {
          // 'asp-standard': ASP responded status:false but express is disabled, so
          // asp-pincode.js's checkItem() already carried the ASP message forward for us.
          // ('asp' — hyperlocal confirmed — is handled first, above.)
          shippingIconHTML = `<div class="shipping-icon">${truckImg}<p>${aspItemResult.message}</p></div>`;
        } else if (isExpress) {
          if (availableStock !== null && quantity <= availableStock) {
            shippingIconHTML = `<div class="shipping-icon freequick">${truckImg}<p>${window.DeliveryConfig.getCartDeliveryText("item")}</p></div>`;
          } else {
            shippingIconHTML = `<div class="shipping-icon">${truckImg}<p>${window.DeliveryConfig.standardItemMessage()}</p></div>`;
          }
        } else {
          shippingIconHTML = `<div class="shipping-icon">${truckImg}<p>${window.DeliveryConfig.standardItemMessage()}</p></div>`;
        }

        const quantityBoxHTML = isWarranty
          ? ""
          : `<span class="quantitybox">
               <button type="button" class="sd_altera sminus">-</button>
               <input type="text" readonly id="updatequant" name="updatequant" value="${quantity}" proid="${item_id}" prosku="${item_sku}" linekey="${variants_key}" data-available-stock="${availableStock}">
               <button type="button" class="sd_altera splus down">+</button>
             </span>`;

        const removeIconHTML =
          isWarranty && isMain
            ? ""
            : `<img class="removeproduct remove" src="https://cdn.shopify.com/s/files/1/0567/7534/4185/files/product-remove.svg?v=1712318457" id="${item_id}" linekey="${variants_key}" height="10" width="10">`;

        return `
          <div class="product-inner row mini-cart-product" id="${item_id}">
            ${removeIconHTML}
            <div class="product_image image">
              <a href="javascript:void(0);"><img loading="lazy" src="${image_url}" height="165" width="165" alt="${product_title}"></a>
            </div>
            <div class="pro-content" id="pro-content">
              <div class="cartproname prohead">
                <h3 class="product_title m-0">${product_title}</h3>
                <div class="prd_variant_style">${variant_title || ""}</div>
              </div>
              <div class="pro-quantity">
                <div class="quantity-selector">
                  <div>
                    <span class="price product_price" id="product_price">
                      <span class="current_price">${currencyES6Format(line_price.toFixed(2))}</span>
                    </span>
                  </div>
                  <div>
                    ${quantityBoxHTML}
                    ${shippingIconHTML}
                  </div>
                </div>
              </div>
            </div>
          </div>`;
      });

      const itemsHTML = await Promise.all(itemPromises);
      $(".product-outer").empty();
      $(".product-outer").append(itemsHTML.join(""));
      $(".cart-dis-txt").show();
      setAspCheckoutBlocked(anyAspBlocked);

      if (showExpressShipping && !allItemsHaveExpressStock) {
        // $(".shipping-at").hide();
        // $(".sd_shipping.default-shipping").show();
        $(".shipping-at").show();
        $(".sd_shipping.default-shipping").hide();
        $(".shipping-at .sd_shipping.express-shipping b").html(
          `<span>Shipping at <strong style="color: #1268f1;">${isPincode}</strong></span>`,
        );
      }
    } else {
      $("#cart_item_count").html("<span>(0)</span> Items in your cart");
      $(".cart-dis-txt").hide();
      $(".product-outer").html(
        `<div class="cart-item-container">
           <div class="media-body empty-media">
             <figure><img src="https://cdn.shopify.com/s/files/1/0621/7603/5053/files/empty-cart.png?v=1668104246" alt="empty-cart"></figure>
             <h3 class="row mini-cart-product">Add items to bag now</h3>
           </div>
           <div class="bottom-cart-box">
             <div class="cart-btn-container">
               <a href="https://shop.symphonylimited.com/collections/all" class="cont-shopping sd_shopproduct" style="display: block;">Shop</a>
             </div>
           </div>
         </div>`,
      );
      $(".minitotal.total,.sd_sidebar_check").hide();
      $(".shipping-at").hide();
      setAspCheckoutBlocked(false);
    }

    if (isExpress && allItemsHaveExpressStock) {
      $(".shipping-at").show();
      $(".sd_shipping.default-shipping").hide();
      // Drop the "- Delivery within 2-3 working days" suffix as soon as any cart item is hyperlocal confirmed
      const expressLabel = anyHyperlocal
        ? `<span>Shipping at <strong style="color: #1268f1;">${isPincode}</strong></span>`
        : `<span>Shipping at <strong style="color: #1268f1;">${isPincode}</strong></span>`;
      $(".shipping-at .sd_shipping.express-shipping b").html(expressLabel);
    } else if (isPincode) {
      $(".shipping-at").show();
      $(".sd_shipping.default-shipping").hide();
      $(".shipping-at .sd_shipping.express-shipping b").html(
        `<span>Shipping at <strong style="color: #1268f1;">${isPincode}</strong></span>`,
      );
    } else {
      $(".shipping-at").hide();
      $(".sd_shipping.default-shipping").hide();
    }

    if (item_count < 1) {
      $(".shipping-at").hide();
      $(".sd_shipping.default-shipping").hide();
    }

    // Remove loader now — all async work (stock check, ASP check, property sync,
    // fresh cart fetch, render) is complete. Cart shows correct final state immediately.
    $("#cart_drawer").removeClass("loader");

    return allItemsHaveExpressStock;
  });
};

// ─── ASP fulfilment (Shopify out-of-stock items) ──────────────────────────────
// Per cart variant: Shopify stock, whether inventory is tracked, whether the product
// has the ASP tag. Rendered by sections/asp-cart-stock.liquid (Section Rendering API).
async function fetchAspCartStock() {
  try {
    const res = await fetch("/?sections=asp-cart-stock");
    if (!res.ok) return {};
    const sections = await res.json();
    const html = sections["asp-cart-stock"] || "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    const json = doc.querySelector("[data-asp-cart-stock]")?.textContent || "{}";
    return JSON.parse(json);
  } catch (err) {
    console.warn("[AspCart] Could not load cart stock data:", err);
    return {};
  }
}

// Disable every checkout option while any ASP-only item isn't confirmed for the current
// pincode/quantity. Payment apps inject their own buttons into the checkout area
// (Razorpay Magic → .checkout_btn, Snapmint EMI → appended into .sd_sidebar_check), possibly
// after we render — so the whole area is blocked via a class + CSS, not individual buttons.
const ASP_CHECKOUT_AREA = "#cart_drawer .sd_sidebar_check";

function setAspCheckoutBlocked(blocked) {
  window.__aspCheckoutBlocked = !!blocked;
  const $area = $(ASP_CHECKOUT_AREA);
  $area.toggleClass("is-asp-blocked", !!blocked);
  $(".checkout_btn").prop("disabled", !!blocked);

  $(".asp-checkout-note").remove();
  if (blocked) {
    const note =
      '<p class="asp-checkout-note">Some items are out of stock at your pincode. Remove them, reduce the quantity or change the pincode to continue.</p>';
    const $btn = $area.find(".checkout_btn").first();
    if ($btn.length) $btn.before(note);
    else $area.prepend(note);
  }
}

// Belt and braces: stop any click inside the checkout area while blocked,
// before the payment apps' own handlers see it
document.addEventListener(
  "click",
  (e) => {
    if (!window.__aspCheckoutBlocked) return;
    if (e.target.closest(".asp-checkout-note")) return;
    if (e.target.closest(ASP_CHECKOUT_AREA) || e.target.closest(".checkout_btn")) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },
  true,
);

var addToCart = (form) => {
  setTimeout(function () {
    dropdowncart();
  }, 700);
};

$(document).on("submit", 'form[action="/cart/add"]', function (e) {
  addToCart(this);
  e.preventDefault();
  e.stopPropagation();
  $("#cart_drawer").addClass("active");
});

$(document).on("click", ".cart_btn", function (e) {
  let cart = {
    id: $(this).attr("variant-id"),
    quantity: 1,
  };
  if (
    simply?.warrantyEnable &&
    !(e.currentTarget?.getAttribute("data-is-warranty-hide") == "true")
  ) {
    simply.extendedWarrantyModal &&
      simply.extendedWarrantyModal(
        cart,
        () => {
          $(".modal--quickshop-slim .modal-close").trigger("click");
          dropdowncart();
          $("#cart_drawer").addClass("active");
        },
        e.currentTarget,
      );
    return false;
  }
  $.post("/cart/add.js", cart)
    .fail(function (error) {
      var errorText = JSON.parse(error.responseText);
      dropdowncart();
      $("#cart_drawer").addClass("active");
    })
    .then(function () {
      $(".modal--quickshop-slim .modal-close").trigger("click");
      dropdowncart();
      $("#cart_drawer").addClass("active");
    });
  e.preventDefault();
  e.stopPropagation();
});

$(
  "button.productitem--action-trigger.productitem--action-atc.button-primary.mdc-ripple-surface.mdc-ripple-upgraded",
).off("click");

$(document).on("click", ".atc--button", function (e) {
  $(".modal--quickshop-full .modal-close").click();
  let cart = {
    id: $(this).data("variant-id"),
    quantity: 1,
  };
  if (
    simply?.warrantyEnable &&
    !(e.currentTarget?.getAttribute("data-is-warranty-hide") == "true")
  ) {
    simply.extendedWarrantyModal &&
      simply.extendedWarrantyModal(
        cart,
        () => {
          $(".modal--quickshop-slim .modal-close").trigger("click");
          dropdowncart();
          $("#cart_drawer").addClass("active");
        },
        e.currentTarget,
      );
    return false;
  }
  $.post("/cart/add.js", cart)
    .fail(function (error) {
      var errorText = JSON.parse(error.responseText);
      dropdowncart();
      $("#cart_drawer").addClass("active");
    })
    .then(function () {
      $(".modal--quickshop-slim .modal-close").trigger("click");
      dropdowncart();
      $("#cart_drawer").addClass("active");
    });
  e.preventDefault();
  e.stopPropagation();
});

var update_header_cart = () => {
  getData().then((data) => {
    var item_count = data["item_count"];
    $(".custom_cart_count").html(item_count);
  });
};
update_header_cart();

$(".cart-icon").on("click", function (e) {
  e.preventDefault();
  dropdowncart();
  $("#cart_drawer").addClass("active");
});

var _updateCartItemQuantity = async (linekey, quantity, upinput) => {
  const sku = upinput && upinput.attr("prosku");
  const variantId = upinput && String(upinput.attr("proid") || "");
  const pincode = window.AspPincodeCart && window.AspPincodeCart.getPincode();

  // Build the change.js payload — starts as qty-only, properties added below if needed
  const payload = { id: linekey, quantity };

  // STEP 1 — ASP check FIRST with new quantity.
  // Result is cached in AspPincodeCart._cache so checkAll in the subsequent
  // dropdowncart() call hits the cache and makes zero additional API calls.
  if (pincode && sku && variantId) {
    try {
      const currentItem =
        window.updatedCartJson &&
        window.updatedCartJson.items &&
        window.updatedCartJson.items.find(
          (i) => String(i.variant_id) === variantId,
        );
      const currentProps = (currentItem && currentItem.properties) || {};

      const aspResult = await window.AspPincodeCart.checkItem(
        sku,
        variantId,
        quantity,
      );

      if (aspResult && aspResult.source === "asp" && aspResult.supplierCode) {
        if (
          currentProps["_isASP"] !== "true" ||
          currentProps["_ASPCode"] !== aspResult.supplierCode
        ) {
          payload.properties = Object.assign({}, currentProps, {
            _isASP: "true",
            _ASPCode: aspResult.supplierCode,
          });
        }
      } else if (currentProps["_isASP"] === "true") {
        payload.properties = Object.assign({}, currentProps, {
          _isASP: "false",
          _ASPCode: null,
        });
      }
    } catch (err) {
      console.error("[Cart] ASP pre-check error:", err);
    }
  }

  // STEP 2 — Single change.js call: qty + properties (if any) combined.
  // checkAll in dropdowncart() will hit the cache → skip property write → skip /cart.js re-fetch.
  try {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (err) {
    console.error("[Cart] qty update error:", err);
  }

  dropdowncart();
};

var updateCartItemQuantity = debounce(_updateCartItemQuantity, 500); // Debounce with 500ms delay

var removecart = (new_id, id_key) => {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: id_key,
      quantity: 0,
    },
  }).then((data) => {
    dropdowncart();
  });
};
simply.reRenderCart = () => {
  dropdowncart();
};
$(document).on("click", ".remove", function (e) {
  e.preventDefault();
  let product_id = this.id;
  let product_key = $(this).attr("linekey");
  $(this).parents(".product-inner").remove();
  if (
    simply?.warrantyEnable &&
    !(e.currentTarget?.getAttribute("data-is-warranty-hide") == "true")
  ) {
    simply.mainProductUpdate(
      { vid: product_id, key: product_key, quantity: 0 },
      () => {
        product_id == simply.warrantyProduct.variants[0].id ||
        product_id == simply.warrantyProductLarge.variants[0].id
          ? simply.reRenderCart()
          : removecart(product_id, product_key);
      },
      e.currentTarget,
    );
  } else {
    removecart(product_id, product_key);
  }
});

$(document).on("click", ".splus", function () {
  $("#cart_drawer").addClass("loader"); // show loader immediately — async work starts below
  const upinput = $(this).parents(".quantitybox").find("input");
  const oldQuantity = parseInt(upinput.val());
  const newQuantity = oldQuantity + 1;

  const isExpress = getCookie("isExpress") === "true";
  const availableStockStr = upinput.attr("data-available-stock");

  if (isExpress && availableStockStr && availableStockStr !== "-1") {
    const availableStock = parseInt(availableStockStr, 10);
    const wasAvailable = oldQuantity <= availableStock;
    const isAvailable = newQuantity <= availableStock;

    if (wasAvailable && !isAvailable) {
      showToast("Express delivery not available for this much quantity", 3000);
    } else if (!wasAvailable && isAvailable) {
      showToast("Express delivery is now available for this quantity!", 3000);
    }
  }

  upinput.val(newQuantity);
  const inc_id = upinput.attr("proid");
  const linekey = upinput.attr("linekey");

  if (simply?.warrantyEnable) {
    simply.mainProductUpdate(
      { vid: inc_id, key: linekey, quantity: newQuantity },
      () => {
        inc_id == simply.warrantyProduct.variants[0].id ||
        inc_id == simply.warrantyProductLarge.variants[0].id
          ? updateCartItemQuantity(linekey, newQuantity, upinput)
          : updateCartItemQuantity(linekey, newQuantity, upinput);
      },
    );
  } else {
    updateCartItemQuantity(linekey, newQuantity, upinput); // Pass upinput here
  }
});

$(document).on("click", ".sminus", function () {
  $("#cart_drawer").addClass("loader"); // show loader immediately — async work starts below
  const upinput = $(this).parents(".quantitybox").find("input");
  const oldQuantity = parseInt(upinput.val());
  if (oldQuantity <= 1) {
    $("#cart_drawer").removeClass("loader");
    return;
  } // Prevent going below 1
  const newQuantity = oldQuantity - 1;

  const isExpress = getCookie("isExpress") === "true";
  const availableStockStr = upinput.attr("data-available-stock");

  if (isExpress && availableStockStr && availableStockStr !== "-1") {
    const availableStock = parseInt(availableStockStr, 10);
    const wasAvailable = oldQuantity <= availableStock;
    const isAvailable = newQuantity <= availableStock;

    if (wasAvailable && !isAvailable) {
      showToast("Express delivery not available for this much quantity", 2000);
    } else if (!wasAvailable && isAvailable) {
      showToast("Express delivery is now available for this quantity!", 2000);
    }
  }

  upinput.val(newQuantity);
  const dec_id = upinput.attr("proid");
  const linekey = upinput.attr("linekey");

  if (simply?.warrantyEnable) {
    simply.mainProductUpdate(
      { vid: dec_id, key: linekey, quantity: newQuantity },
      () => {
        dec_id == simply.warrantyProduct.variants[0].id ||
        dec_id == simply.warrantyProductLarge.variants[0].id
          ? updateCartItemQuantity(linekey, newQuantity, upinput)
          : updateCartItemQuantity(linekey, newQuantity, upinput); // Pass upinput here
      },
    );
  } else {
    updateCartItemQuantity(linekey, newQuantity, upinput); // Pass upinput here
  }
});

document.addEventListener("click", function (e) {
  if (e.target.closest(".sides_cross_image")) {
    document.body.style.overflow = "auto";
    document.getElementById("cart_drawer")?.classList.remove("active");
    $(".shipping-at").hide();
    document.body.style.overflow = "auto";
  }
});

document.addEventListener("click", function (event) {
  if (!isCartOpen) {
    if (
      !$(event.target).closest(".custom-cart").length &&
      !$(event.target).hasClass("removeproduct")
    ) {
      isCartOpen = false;
      $("body").css("overflow", "auto");
      $("#cart_drawer").removeClass("active");
    }
  }
  isCartOpen = false;
});

$("body").append(
  '<div id="cart_drawer" class="cart_drawer"><div class="custom-cart"><div class="custom-cart-loader"></div><div id="cart-pincode-popup" class="cart-pincode-popup" style="display:none;"><div class="cart-pincode-overlay"></div><div class="cart-pincode-modal"><h3>Enter Pincode For Best Price</h3><input type="text" id="cart-pincode-input" class="cart-pincode-input" placeholder="Enter Pincode" maxlength="6"><p class="cart-pincode-error" style="display:none; color:red; font-size:12px;">Please enter a valid 6-digit pincode</p></div></div><ul class="cart-dis-txt"><li>Best price guaranteed*</li><li>Automatic warranty registration</li><li>Secure payment</li></ul><div class="title-close-wrapper"><div class="productbox" id="productbox"><h3 class="heading" id="cart_item_count"><span>(0)</span>Items in your cart</h3></div><div class="sides_cross_image"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0567/7534/4185/files/Group_205536.svg?v=1712305707" height="30" width="30" alt="close logo"></div></div><form action="/cart" method="post" class="custom_cartform" name="cartform"><div class="product-outer"></div></form><div class="shipping-at" style="display: none;"><p class="sd_shipping express-shipping"><b>Loading...</b></p></div><div class="cart-total-box"><div class="minitotal total"><div class="convenience"><span class="convenience-text">Convenience Fee</span> <p id="convenience-total" class="convenience-total"><span>₹800</span> ₹ 0</p></div><div class="totalname">Subtotal<strong id="mini_cart_total" class="totalprice">₹ 0,00,00</strong></div><div class="sd_sidebar_check"><p class="sd_shipping default-shipping" style="display: none;"><b>Free Shipping Nationwide<br class="d-768"></b></p><input id="sd_valid_discount" type="hidden" name="discount"><button name="checkout" class="checkout_btn magicbutton"><div>Express Checkout </br> <span style="font-size: 12px;">3% off on UPI | 18% GST Benefit</span></div><img src="https://cdn.shopify.com/s/files/1/0567/7534/4185/files/Upi_payment_icon_97a5170f-1a51-4028-98a1-4ed8634c26ce.png?v=1714128845" alt="upi"/></button></div><div class="offers-content"><div class="upi-offers"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0567/7534/4185/files/upi-offer.svg?v=1712305707" height="30" width="30" alt="UPI"><p>Get <strong>₹000</strong> Discount using UPI payment Mode</p></div><div class="emi-offers"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0567/7534/4185/files/emi-offer.svg?v=1712305707" height="30" width="30" alt="EMI"><p>No Cost EMI from<strong>16+</strong>Banks</p></div><div class="gst-offers"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0567/7534/4185/files/gst-offer.svg?v=1712305707" height="30" width="30" alt="GST"><p>Save <strong>₹000</strong> on Business Purchases (GST)</p></div></div></div></div></div>',
);

// Cart Pincode Popup Functions
function showCartPincodePopup() {
  $("#cart-pincode-popup")
    .stop(true, true)
    .css("display", "flex")
    .hide()
    .fadeIn(300);
}

function hideCartPincodePopup() {
  $("#cart-pincode-popup").stop(true, true).fadeOut(300);
  $("#cart-pincode-input").val("");
  $(".cart-pincode-error").hide();
}

function getCurrentProductId() {
  return window.meta?.product?.id || null;
}

function getCartDeliveryContext(pincode) {
  if (typeof PincodeExpress?.getDeliveryContext === "function") {
    return PincodeExpress.getDeliveryContext(pincode, getCurrentProductId());
  }

  return null;
}

function updateAllPincodeDisplays(pincode, isExpress) {
  const svgArrowHTML =
    '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1836 1.0542L5.61968 5.61816L1.05469 1.0542" stroke="#3B3C3D" stroke-width="2.10835" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  const deliveryContext = getCartDeliveryContext(pincode);
  let expressMessage =
    deliveryContext?.matched && deliveryContext.expressMessage
      ? deliveryContext.expressMessage
      : window.DeliveryConfig?.getExpressMessage?.() ||
        "Delivery within 2-3 working days";
  // Porter / custom delivery → gradient pill markup
  if (
    deliveryContext?.isCustom &&
    typeof window.DeliveryConfig?.formatPorterPdpHtml === "function"
  ) {
    expressMessage = window.DeliveryConfig.formatPorterPdpHtml(expressMessage);
  }
  const standardMessage =
    deliveryContext?.matched && deliveryContext.standardMessage
      ? deliveryContext.standardMessage
      : window.DeliveryConfig?.standardMessage?.() ||
        "Free delivery available at your pincode";

  if (pincode) {
    $(".pincode-checker .subtext, .pincode-checker-mob .subtext").html(
      `Deliver to ${pincode} ${svgArrowHTML}`,
    );

    // Hide cart pincode popup if pincode is updated
    hideCartPincodePopup();
  }

  const $pdpPincodeInput = $(".pincode-input-pdp");
  const $pdpSubmitBtn = $(".pin-submit-pdp");
  const $pdpPinCodeTitle = $("#pdp-pincode-section .title");
  const $pdpExpressMsg = $(".express-delivery-msg-pdp");
  const $pdpStandardMsg = $(".standard-delivery-msg-pdp");

  if ($pdpPincodeInput.length) {
    if (pincode) {
      $pdpPincodeInput.val(pincode);
      $pdpSubmitBtn.text("Update");
      $pdpPinCodeTitle.text("Enter Pincode");
    }

    if (isExpress === true || deliveryContext?.matched) {
      $pdpExpressMsg.show();
      $pdpExpressMsg.html(expressMessage);
      $pdpStandardMsg.hide();
    } else if (!isExpress) {
      $pdpExpressMsg.hide();
      $pdpStandardMsg.show();
      $pdpStandardMsg.html(standardMessage);
    } else {
      $pdpExpressMsg.hide();
      $pdpStandardMsg.hide();
    }
  }
}

async function submitCartPincode() {
  const pincode = $("#cart-pincode-input").val().trim();
  let isExpress = false;
  const deliveryContext = getCartDeliveryContext(pincode);

  if (!/^[1-9][0-9]{5}$/.test(pincode)) {
    $(".cart-pincode-error").show();
    return;
  }

  $(".cart-pincode-error").hide();

  if (typeof PincodeExpress !== "undefined") {
    isExpress =
      Boolean(deliveryContext?.matched) ||
      PincodeExpress.isExpressPincode(pincode, getCurrentProductId());
    const sapCode = PincodeExpress.getSapCodeForPincode(
      pincode,
      getCurrentProductId(),
    );

    setCookie("user_pincode", pincode, 30);
    setCookie("isExpress", isExpress, 30);
    setCookie("sapCode", sapCode, 30);
    updateAllPincodeDisplays(pincode, isExpress);

    hideCartPincodePopup();
    const allItemsHaveExpressStock = await dropdowncart();

    const toastMessage = deliveryContext?.matched
      ? deliveryContext.cartMessage || deliveryContext.expressMessage
      : isExpress && allItemsHaveExpressStock
        ? window.DeliveryConfig.getExpressMessage()
        : "Free delivery available at your pincode";

    showToast(toastMessage, 3000);

    if (window.meta?.product) {
      const $pdpExpressMsg = $(".express-delivery-msg-pdp");
      const $pdpStandardMsg = $(".standard-delivery-msg-pdp");
      const $qtyInput = $(".product-qty");

      // Get current selected variant SKU
      const currentVariant =
        window.meta.product.selected_or_first_available_variant;

      const sku = window.meta.product?.variants[0]?.sku;

      async function updateDeliveryMessage() {
        try {
          const quantity = parseInt($qtyInput.val(), 10) || 1;

          if (!sku) {
            console.warn("SKU not found");
            return;
          }

          const stockResults = await window.SymphonyStockChecker.checkStock(
            [sku],
            sapCode,
          );

          const productStock = stockResults.find(
            (item) => item.Material === sku,
          );

          const availableStock = productStock
            ? parseInt(productStock.Quantity, 10)
            : 0;

          if (quantity <= availableStock) {
            $pdpStandardMsg.hide();

            $pdpExpressMsg
              .html(window.DeliveryConfig.getPdpDeliveryText())
              .show();
            $pdpStandardMsg.html("Loading...");
          } else {
            $pdpExpressMsg.hide();

            $pdpStandardMsg
              .html(window.DeliveryConfig.standardMessage())
              .show();
            $pdpExpressMsg.html("Loading...");
          }
        } catch (error) {
          console.error("Stock check failed:", error);
        }
      }

      // Initial check (default qty = 1)
      updateDeliveryMessage();
    }

    // Reset express delivery on collection pages
    if (typeof window.resetExpressDelivery === "function") {
      window.resetExpressDelivery();
    }
  } else {
    setCookie("user_pincode", pincode, 30);
    hideCartPincodePopup();
    await dropdowncart();
    showToast("Free delivery available at your pincode", 3000);
  }

  fireCartPincodeGAEvent(pincode, isExpress, "cart");
}

$(document).on("input", "#cart-pincode-input", function () {
  this.value = this.value.replace(/\D/g, "");

  if (this.value.length < 6) {
    $(".cart-pincode-error").hide();
    return;
  }

  submitCartPincode();
});

$(document).on("click", "#cart-pincode-submit", function () {
  submitCartPincode();
});

$(document).on("click", ".cart-pincode-overlay", function (e) {
  e.stopPropagation();
  // Don't close - user must enter pincode
});

document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".snap-compare-add-to-cart");
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    isCartOpen = true;

    $.post("/cart/add.js", { id: variantId, quantity: 1 })
      .then(function () {
        dropdowncart();
        $("#cart_drawer").addClass("active");
      })
      .fail(function (err) {
        const error = JSON.parse(err.responseText);
        alert(error.description || "Error adding to cart");
      });
  },
  true,
);
